import { render, staticRenderFns } from "./UldkInfo.vue?vue&type=template&id=567aafca&scoped=true&"
import script from "./UldkInfo.vue?vue&type=script&lang=js&"
export * from "./UldkInfo.vue?vue&type=script&lang=js&"
import style0 from "./UldkInfo.vue?vue&type=style&index=0&id=567aafca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567aafca",
  null
  
)

export default component.exports